import { StyleSheet, Text, TextProps } from "react-native";

import { Fonts } from "@/constants/theme";

export function GText({ style, ...rest }: TextProps) {
  return <Text style={[styles.base, style]} {...rest} />;
}

const styles = StyleSheet.create({
  base: {
    fontFamily: Fonts?.sans,
  },
});
